import React from 'react'
import PropTypes from 'prop-types'
import StepperType from './StepperType'

class Step extends React.Component {
  static propTypes = {
    // name attribute is used in StepSwitch
    // eslint-disable-next-line react/no-unused-prop-types
    name: PropTypes.string,
    component: PropTypes.oneOfType([PropTypes.element, PropTypes.func, PropTypes.elementType]),
    stepper: StepperType,
    parentStepper: StepperType,
    children: PropTypes.node,
  }

  static displayName = 'Step'

  constructor(props) {
    super(props)
    this.validateProps()
  }

  componentDidMount() {
    window.scrollTo(0, 0)
  }

  validateProps() {
    const { component, children } = this.props
    if (!component && !children) {
      throw new Error('Missing Step component attribute or children')
    }
  }

  render() {
    const {
      component,
      children,
      stepper,
      parentStepper,
      // eslint-disable-next-line no-unused-vars
      name,
      ...rest
    } = this.props

    const elProps = { stepper, parentStepper, ...rest }
    if (component && !React.isValidElement(component)) {
      return React.createElement(component, elProps)
    }

    const elements = component || children
    return React.Children.map(elements, (element) => {
      return React.cloneElement(element, elProps)
    })
  }
}

export default Step
